import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  ul: {
    background: theme.palette.card.cardColor,
    color: theme?.palette?.card?.cardFontColor,
    "& ul": {
      color: theme.palette.card.cardFontColor,
      background: theme.palette.card.cardColor,
    },
  },
  selectMenu: {
    background: theme.palette.card.cardColor,
    "& li": {
      color: theme.palette.card.cardFontColor,
    },
  },
}));

function CheckoutDateSlotPicker({
  slots = [],
  className,
  value,
  onChange = () => {},
  onClick = () => {},
  setDate = () => {},
}) {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState("");


  // Update selectedDate when value prop changes
  useEffect(() => {
    if (value && value.value) {
      setSelectedDate(value.value);
    }
  }, [value]);

  // Set default date if no value is provided and slots are available
  useEffect(() => {
    if (!selectedDate && slots.length > 0 && !value?.value) {
      setSelectedDate(slots[0].date);
    }
  }, [slots, selectedDate, value]);

  // Ensure selectedDate is set when both value and slots are available
  useEffect(() => {
    if (value?.value && slots.length > 0) {
      // If we have a value but selectedDate is empty, set it
      if (!selectedDate) {
        setSelectedDate(value.value);
      }
    }
  }, [value, slots, selectedDate]);

  // Force update when slots change and we have a value
  useEffect(() => {
    if (value?.value && slots.length > 0) {
      // Check if the current value exists in the slots
      const slotExists = slots.find(slot => slot.date === value.value);
      if (slotExists && selectedDate !== value.value) {
        setSelectedDate(value.value);
      } else if (!slotExists) {
        // Try to find by date comparison using moment.js
        const valueMoment = moment(value.value, "LL");
        if (valueMoment.isValid()) {
          const matchingSlot = slots.find(slot => {
            const slotMoment = moment(slot.date, "LL");
            return slotMoment.isValid() && slotMoment.isSame(valueMoment, 'day');
          });
          
          if (matchingSlot) {
            setSelectedDate(matchingSlot.date);
          }
        }
      }
    }
  }, [slots, value, selectedDate]);

  // Update parent's date state when selectedDate changes
  useEffect(() => {
    if (selectedDate) {
      setDate(selectedDate);
    }
  }, [selectedDate, setDate]);

  const handleChange = (e) => {
    const newSelectedDate = e.target.value;
    
    // Update the local state immediately
    setSelectedDate(newSelectedDate);
    
    // Find the selected slot
    const selected = slots.find((slot) => slot.date === newSelectedDate);
    if (selected && onChange) {
      // Pass expected shape back to parent
      onChange({ value: newSelectedDate }, "date");
    }
  };

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <FormControl variant="outlined" className={className}>
      <Select
        labelId="delivery-date"
        id="delivery-date-select"
        value={selectedDate}
        onChange={handleChange}
        onClick={handleClick}
        label="Date"
        MenuProps={{
          classes: { paper: classes.selectMenu },
        }}
        className={`slotSelectorFont font-weight-bold ${classes.ul}`}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {slots.map((elem, key) => (
          <MenuItem key={`option-${key}`} value={elem.date}>
            {elem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

CheckoutDateSlotPicker.defaultProps = {
  slots: [],
  className: "",
  value: null,
  onChange: () => {},
  onClick: () => {},
  setDate: () => {},
};

CheckoutDateSlotPicker.propTypes = {
  slots: PropTypes.array,
  className: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  setDate: PropTypes.func,
};

export default CheckoutDateSlotPicker; 